import React from 'react';
import { useTranslation } from 'react-i18next';
import { AppButton, useResponsive } from '@common-fe/common-fe';

import { WarnModal } from '@/components/elements';
import { CardActivationModalType } from '@/modules/transaction/components/Cards/Cards.types';

import { useCardActivationModal } from './hooks/useCardActivationModal';

const SUBMIT_BUTTON_WIDTH = '160px';

export const CardActivationModal = () => {
  const { t } = useTranslation();
  const { isMobile } = useResponsive();
  const {
    modalVisible,
    modalType,
    currentModalHeader,
    currentSubmitButtonText,
    currentSubmitButtonHandler,
    handleSubmitClose,
  } = useCardActivationModal();

  return (
    <WarnModal
      testId={`CardActivationModal-${modalType}`}
      header={currentModalHeader}
      visible={modalVisible}
      onSetVisible={handleSubmitClose}
      isSuccessIcon={modalType === CardActivationModalType.Processing}
      isPendingIcon={modalType === CardActivationModalType.Activation}
      paddingless
      buttonText={modalType === CardActivationModalType.Processing ? undefined : t('Cancel')}
      submitButtonNode={
        <AppButton
          fill={isMobile}
          testId="CardActivationModal-submit-button"
          onClick={currentSubmitButtonHandler}
          width={SUBMIT_BUTTON_WIDTH}
        >
          {currentSubmitButtonText}
        </AppButton>
      }
      onSubmit={currentSubmitButtonHandler}
    />
  );
};
